import Vue from "vue";
import store from "../index";

const state = {
  token: null,
  user: {
    user: undefined,
    settings: undefined
  }
};

// getters
const getters = {
  getBearer: state => {
    return state.token ? `Bearer ${state.token}` : null;
  },
  logged: state => {
    try {
      return !!(
        state.token || (state.token = Vue.prototype.$localStorage.get("token"))
      );
    } catch (e) {
      return false;
    }
  },
  user: state => {
    return state.user.user;
  },
  settingsLocale: state => {
    try {
      return state.user.settings.settings.locale;
    } catch (e) {
      return null;
    }
  },
  getSettings: state => {
    try {
      return state.user.settings;
    } catch (e) {
      return {};
    }
  }
};

// actions
const actions = {
  user(state, data) {
    state.commit("setUser", data);
  },
  logout: state => {
    state.commit("setToken", null);
    state.commit("setUser", null);
    Vue.prototype.$keycloak.logoutFn();
  }
};

// mutations
const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setUser(state, user) {
    state.user.user = user;
  },
  setLocale(state, locale) {
    try {
      state.user.settings.settings.locale = locale;
    } catch (e) {
      try {
        state.user.settings = {
          settings: {
            locale: locale
          }
        };
      } catch (e) {
        return store.commit("setLocale", locale);
      }
    }
    store.commit("setLocale", state.user.settings.settings.locale);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
